import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

export const FilterSkeletonText = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: "10px",
  lineHeight: "13.35px",
  marginRight: "5px",
  color: theme.palette.text.primary,
  marginTop: "5px",
}));
